export let nationalCodeRegexp = /^(?!(\d)\1{9})\d{10}$/;
export let shebaRegexp = /^[ 0-9۰-۹]*$/;
export let mobileNumberRegexp = /^[0-9\b]+$/;
export let numberRegexp = /^[0-9\b]+$/;
export let mobileNumberIranRegexp =  /^(0[0-9]{10}|۰[۰-۹]{10})$/;

